import type { CanvasChatMessage } from './canvas-types';

/** A lost transport is not a terminal result for a durable concept run. */
export function recoverDetachedConceptRun(
  projectId: number | null,
  messageId: string,
  messages: CanvasChatMessage[],
  write: (update: (messages: CanvasChatMessage[]) => CanvasChatMessage[]) => void,
  watch: (projectId: number, messageId: string, setId: number | null) => Promise<void>,
): boolean {
  if (projectId == null) return false;
  const message = messages.find(candidate => candidate.id === messageId);
  if (message?.conceptsRun?.status !== 'generating') return false;
  write(current => current.map(candidate =>
    candidate.id === messageId && candidate.conceptsRun?.status === 'generating'
      ? { ...candidate, isStreaming: false, agentThinking: undefined }
      : candidate,
  ));
  void watch(projectId, messageId, message.conceptsRun.setId ?? null).catch(() => {});
  return true;
}
